import React from 'react';

const InvisibleEye: React.FC = () => {
  return (
    <svg
      height="32px"
      width="32px"
      viewBox="0 0 32 32"
      style={{
        fill: '#4b585d',
      }}
    >
      <path d="M25.95 6.215c.294.287.294.752 0 1.04L6.988 25.784c-.294.287-.77.287-1.063 0-.294-.287-.294-.752 0-1.04l18.962-18.53c.293-.287.77-.287 1.063 0zm-2.764 4.78c1.447.844 2.83 1.958 4.142 3.336.885.929.896 2.362.03 3.306l-.033.036-.096.1C23.906 21.216 20.141 22.98 16 22.98c-1.507 0-2.963-.233-4.367-.696l1.206-1.178c1.026.27 2.08.405 3.161.405 3.667 0 7.015-1.551 10.044-4.652l.091-.095.093-.096.023-.026c.335-.376.327-.942-.023-1.31-1.32-1.384-2.7-2.472-4.142-3.263l1.1-1.075zM16 9.02c1.473 0 2.898.223 4.273.665l-1.211 1.183c-.995-.252-2.015-.379-3.062-.379-3.667 0-7.015 1.551-10.044 4.652l-.091.095-.093.096-.023.026c-.335.376-.327.942.023 1.31 1.295 1.359 2.65 2.431 4.062 3.218L8.736 20.96c-1.419-.84-2.775-1.938-4.064-3.29-.885-.93-.896-2.363-.03-3.307l.033-.036.096-.1C8.094 10.784 11.859 9.02 16 9.02zm4.196 4.896c.322.627.503 1.335.503 2.084 0 2.57-2.132 4.653-4.762 4.653-.766 0-1.49-.177-2.132-.491l1.151-1.125c.31.095.64.147.981.147 1.8 0 3.258-1.426 3.258-3.184 0-.334-.052-.656-.15-.959l1.151-1.125zm-4.259-2.57c.767 0 1.491.178 2.133.492l-1.151 1.125c-.31-.095-.64-.147-.982-.147-1.799 0-3.258 1.426-3.258 3.184 0 .334.053.656.15.959l-1.15 1.125c-.322-.627-.503-1.335-.503-2.084 0-2.57 2.132-4.653 4.761-4.653z" />
    </svg>
  );
};

export default InvisibleEye;
